<script setup>
import Popup from '@/components/controls/Popup.vue';
import Checkbox from '@/components/controls/Checkbox.vue';
import Icon from '@/components/icons/Icon.vue';

const props = defineProps({
  containerTypes: {
    type: Set,
    required: true
  },
  showTextLabel: {
    type: String,
    default: true,
  },
  surface: {
    type: Number,
    default: () => 1
  }
});

const activeContainerTypes = defineModel({ required: true });
</script>

<template>
  <Popup
    v-if="containerTypes.size > 1"
    :id="`favorite-container-type-popup`"
    positionY="bottom"
    positionX="center"
  >
    <template #button-content>
      <div
        class="jwx-dropdown-control"
        type="button"
        :data-surface="props.surface"
      >
        <Icon name="filter" class="jwx-dropdown-control__icon" />
        <p v-if="showTextLabel" class="jwx-dropdown-control__label">Filter Containers</p>
        <Icon name="chevron-up-down" class="jwx-dropdown-control__action-icon" />
      </div>
    </template>
    <template #menu-content>
      <div
      class="jwx-multiselect-menu"
      style="min-width: 7.8125rem; max-height: 50vh;"
      >
        <ul class="jwx-multiselect-menu__list">
          <li
            v-for="type in containerTypes"
            :key="type"
            class="jwx-multiselect-menu__option"
          >
            <Checkbox
              :id="`container-type-${type}`"
              :name="`container-type-${type}`"
              :checked="activeContainerTypes.has(type)"
              :value="type"
              labelClassList="jwx-multiselect-menu__option-label"
              v-model="activeContainerTypes"
            >
                <div class="jwx-multiselect-menu__label-name">{{ type }}</div>
            </Checkbox>
          </li>
        </ul>
      </div>
    </template>
  </Popup>
</template>